<div class="step-confirmation">
  <div class="step-header">
    <div>
      <h3>Confirmação</h3>
      <p class="step-subtitle">
        Revise tudo abaixo antes de disparar a geração. Ao confirmar, o
        processo será executado em segundo plano e os pedidos/faturas serão
        criados conforme a configuração definida.
      </p>
    </div>
  </div>

  <div class="info-card">
    <div class="info-row">
      <div class="info-item">
        <span class="info-label">Descrição</span>
        <span class="info-value">{{ process.description }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Período</span>
        <span class="info-value">{{ periodLabel }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Empresa</span>
        <span class="info-value">{{ companyLabel }}</span>
      </div>
      <div class="info-item" *ngIf="franchisePeriodLabel">
        <span class="info-label">Franquia (período)</span>
        <span class="info-value">{{ franchisePeriodLabel }}</span>
      </div>
    </div>
  </div>

  <section class="section">
    <div class="section-title">
      <i class="pi pi-list-check"></i>
      <span>Pedidos a gerar</span>
      <span class="section-total">
        {{ totalOrders }} · {{ totalOrdersValue | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
      </span>
    </div>

    <div class="summary-grid">
      <div class="summary-card" *ngFor="let s of summaries" [class.empty]="s.count === 0">
        <div class="summary-card-header">
          <i [class]="s.icon"></i>
          <span class="summary-card-title">{{ s.title }}</span>
        </div>
        <div class="summary-card-body">
          <div class="summary-row">
            <span class="summary-row-label">Quantidade</span>
            <span class="summary-row-value">{{ s.count }}</span>
          </div>
          <div class="summary-row">
            <span class="summary-row-label">Valor</span>
            <span class="summary-row-value money">
              {{ s.total | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section" *ngIf="preview">
    <div class="section-title">
      <i class="pi pi-file"></i>
      <span>Faturas previstas</span>
      <span class="section-total" *ngIf="!skipInvoiceGeneration">
        {{ preview.totalInvoices }} · {{ preview.totalValue | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
      </span>
      <span class="skip-badge" *ngIf="skipInvoiceGeneration">
        <i class="pi pi-ban"></i> Não serão geradas
      </span>
    </div>

    <div class="invoice-summary" *ngIf="!skipInvoiceGeneration">
      <div class="invoice-summary-item">
        <span class="invoice-summary-label">Total de faturas</span>
        <span class="invoice-summary-value">{{ preview.totalInvoices }}</span>
      </div>
      <div class="invoice-summary-item">
        <span class="invoice-summary-label">Valor total</span>
        <span class="invoice-summary-value money">
          {{ preview.totalValue | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
        </span>
      </div>
      <div class="invoice-summary-item" *ngIf="hasMultiCompany">
        <span class="invoice-summary-label">Empresas</span>
        <span class="invoice-summary-value">{{ preview.byCompany.length }}</span>
      </div>
    </div>

    <div class="company-breakdown" *ngIf="!skipInvoiceGeneration && hasMultiCompany">
      <div class="company-chip" *ngFor="let c of preview.byCompany">
        <span class="company-label">
          {{ c.billingCompanyId ? 'Empresa #' + c.billingCompanyId : 'Empresa principal' }}
        </span>
        <span class="company-stats">
          {{ c.invoiceCount }} · {{ c.totalValue | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
        </span>
      </div>
    </div>
  </section>

  <section class="section" *ngIf="settings">
    <div class="section-title">
      <i class="pi pi-cog"></i>
      <span>Configurações aplicadas</span>
    </div>

    <div class="config-grid">
      <div class="config-item">
        <span class="config-label">Data de emissão</span>
        <span class="config-value">{{ formatDate(settings.referenceDate) }}</span>
      </div>
      <div class="config-item">
        <span class="config-label">Data de competência</span>
        <span class="config-value">{{ formatDate(settings.competenceDate) }}</span>
      </div>
      <div class="config-item">
        <span class="config-label">Vencimento</span>
        <span class="config-value">{{ dueDateLabel }}</span>
      </div>
      <div class="config-item">
        <span class="config-label">Fatura separada por pedido</span>
        <span class="config-value">{{ settings.separatelyByOrder ? 'Sim' : 'Não' }}</span>
      </div>
      <div class="config-item">
        <span class="config-label">Envio automático de e-mail</span>
        <span class="config-value">{{ settings.autoSendEmail ? 'Sim' : 'Não' }}</span>
      </div>
      <div class="config-item">
        <span class="config-label">Geração automática de boletos</span>
        <span class="config-value">{{ settings.generateBoletos ? 'Sim' : 'Não' }}</span>
      </div>
    </div>
  </section>

  <section class="section" *ngIf="lockedCount > 0 || totalOrders === 0">
    <div class="section-title">
      <i class="pi pi-exclamation-triangle"></i>
      <span>Avisos</span>
    </div>

    <div class="warnings">
      <div class="warning-row" *ngIf="alreadyGeneratedCount > 0">
        <i class="pi pi-info-circle"></i>
        <span>
          <strong>{{ alreadyGeneratedCount }}</strong> item(ns) já foram gerados neste mês —
          não serão incluídos nesta execução.
        </span>
      </div>
      <div class="warning-row" *ngIf="emitterBlockedCount > 0">
        <i class="pi pi-lock"></i>
        <span>
          <strong>{{ emitterBlockedCount }}</strong> item(ns) bloqueado(s) por outro processo
          em execução. Aguarde a finalização ou desbloqueie antes de continuar.
        </span>
      </div>
      <div class="warning-row danger" *ngIf="totalOrders === 0">
        <i class="pi pi-times-circle"></i>
        <span>
          <strong>Nenhum item selecionado.</strong>
          Volte às etapas anteriores e marque ao menos um item para que o processo possa ser executado.
        </span>
      </div>
    </div>
  </section>

  <div class="step-actions">
    <button pButton type="button" class="easymarine secondary"
      icon="pi pi-arrow-left" label="Anterior"
      [disabled]="loading" (click)="back.emit()"></button>
    <button pButton type="button" class="easymarine primary confirm-btn"
      icon="pi pi-check" iconPos="right" label="Confirmar e gerar"
      [disabled]="!canConfirm" (click)="next.emit()"></button>
  </div>
</div>
